import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import axios from 'axios';

import { AppContext } from '../../context.js';

import Loading from '../components/loading.js';
import Helmet from "../components/helmet.js";

import { Status, Button } from '../components/component.js';

import { TimestampToDate, DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

function getPartnerStatusLabel(statusType) {
  const statusMap = {
    "TO_DO": "Submitted",
    "COMPLETED": "Approved",
    "CANCELED": "Denied"
  };
  return statusMap[statusType] || statusType;
}

function Referral() {
  const context = useContext(AppContext);

  let { id } = useParams();
  
  let referralID = id;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [referral, setReferral] = useState(null);
  const [template, setTemplate] = useState(null);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/partner/referrals/get', {
        id: referralID
      }),
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((referral, settings) => {
      setReferral(referral.data.referral);
      setTemplate(referral.data.template);
      setSettings(settings.data);

      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  function renderPages() {
    return referral.pages.map((page) => {
      return (
        <div key={page.id} className="card mb-2">
          <div className="card-header sm">
            <div className="typo-strong-175">{page.title}</div>
          </div>
          <div className="card-content sm">
            {page.lines.map((line, index) => renderLine(page.id, line, page.lines.length === index + 1))}
          </div>
        </div>
      );
    });
  }

  function renderLine(pageID, line, isLastLine) {
    return (
      <div key={"page_"+pageID+"_line_"+line.id} className={"row " + (isLastLine ? "" : "mb-2")}>
        {line.map((lineField, index) => {
          let field = referral.fields.find((f) => f.code === lineField.code);

          return (
            <div key={"page_"+pageID+"_line_"+line.id+"_field_"+field.code} className={`col-xs-${lineField.size} py-0`}>
              <div className="typo-strong-150">{field.title}:</div>
              <div className="typo-normal-150">
                {field.answers && field.answers.length > 0 ? field.answers[0] : '-'}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet title="Referral" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex justify-content-between align-items-center">
                <span className="typo-hero-small">Referral</span>
              </div>
              <div className="w-25 text-end">
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            
            <div className="card shadowmore mb-4">
              <div className="card-header sm">
                <div className="row">
                  <div className="col-xs-6">
                    <div className="typo-strong-175">{referral.firstName + " " + referral.lastName}</div>
                    <div className="typo-normal-150">{referral.partnerName}</div>
                  </div>
                  <div className="col-xs-6 text-end">
                    {referral.statusType === "TO_DO" && (
                      <Status color={'grey'} muted={true} text={getPartnerStatusLabel(referral.statusType)} />
                    )}
                    {referral.statusType === "COMPLETED" && (
                      <Status color={'green'} muted={true} text={getPartnerStatusLabel(referral.statusType)} />
                    )}
                    {referral.statusType === "CANCELED" && (
                      <Status color={'red'} muted={true} text={getPartnerStatusLabel(referral.statusType)} />
                    )}
                    <div className="typo-normal-125 mt-2">{DateToFormat(DatetimeToDate(referral.createdAt), context.dateFormat)} {DateToFormat(DatetimeToDate(referral.createdAt), context.timeFormat === "us" ? "AMPM" : "HH:mm")}</div>
                  </div>
                </div>
              </div>
              <div className="card-content sm">
                <div className="row mb-2">
                  <div className="col-xs-4">
                    <div className="typo-strong-150">First Name:</div>
                    <div className="typo-normal-150">{referral.firstName}</div>
                  </div>
                  <div className="col-xs-4">
                    <div className="typo-strong-150">Last Name:</div>
                    <div className="typo-normal-150">{referral.lastName}</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xs-4">
                    <div className="typo-strong-150">Email Address:</div>
                    <div className="typo-normal-150">{referral.email}</div>
                    <div className="typo-strong-150 mt-2">Phone Number:</div>
                    <div className="typo-normal-150">{referral.phone}</div>
                  </div>
                  <div className="col-xs-8">
                    <div className="typo-strong-150">Message:</div>
                    <div className="typo-normal-150">{referral.message}</div>
                  </div>
                </div>
              </div>
            </div>

            {renderPages()}

            {referral.importID && (
              <div className="card mt-4">
                <div className="card-header sm">
                  <div className="typo-strong-175">Import Group</div>
                  <div className="typo-normal-125 mb-2">This referral is part of an import group</div>
                  <div onClick={() => navigate(`/referrals?importID=${referral.importID}`)} className="item grey typo-normal-150">
                    View all referrals from this import
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}

export default Referral;

